module.exports = __webpack_public_path__ + "static/media/letsbuild.5d8230d4.png";